import { apiClient } from "@/lib/auth/apiClient";
import { User } from "@/lib/auth/types";
import { useQuery } from "@tanstack/react-query";
export interface AuthResponse {
    user: User;
  }

  export function useUser() {
    return useQuery<User>({
      queryKey: ["user"],
      queryFn: async () => {
          const res = await apiClient.get<AuthResponse>( "/auth" );
        
        return res.user;
      },
      retry: false,
      staleTime: 5 * 60 * 1000, // 5 min cache
    });
  }
 export async function clientLogout(accessToken?: string) {
  const apiBaseUrl = process.env.NEXT_PUBLIC_API_URL;

  await fetch(`${apiBaseUrl}/auth/logout`, {
    method: "POST",
    credentials: "include", // 🔥 bitno
    headers: accessToken
      ? { Authorization: `Bearer ${accessToken}` }
      : undefined,
  });
}